export const apiRoute = '/api/';

export const uploadRoute = '/api/upload';
export const applicationRoute = '/api/sendApplication';